export default "__VITE_ASSET__Bhwm_y_h__"